module.exports = __webpack_public_path__ + "img/IMG_8155_L_Black.47c97007.jpg";